/* eslint-disable @typescript-eslint/no-this-alias */
/* 
 This implementation allows us to track event listeners attached globally
 so that we can later remove them as needed
*/
(function()
{
    if(typeof EventTarget === 'undefined') return;

    const target = EventTarget.prototype;
    const functionName = 'addEventListener';
    const func = target[functionName];

    const symbolHidden = Symbol('hidden');

    function hidden(instance)
    {
        if(instance[symbolHidden] === undefined)
        {
            const area = {};
            instance[symbolHidden] = area;
            return area;
        }

        return instance[symbolHidden];
    }

    function listenersFrom(instance)
    {
        const area = hidden(instance);
        if(!area.listeners) { area.listeners = []; }
        return area.listeners;
    }

    target[functionName] = function(type, listener)
    {
        const listeners = listenersFrom(this);

        listeners.push({ type, listener });

        func.apply(this, arguments);
    };

    target['removeEventListeners'] = function(targetType)
    {
        const self = this;

        const listeners = listenersFrom(self);
        const removed = [];

        listeners.forEach(item =>
        {
            const type = item.type;
            const listener = item.listener;

            if(type == targetType)
            {
                removed.push(type);
                self.removeEventListener(type, listener);
            }
        });

        return removed;
    };

    window.__removeEventListeners = target['removeEventListeners'];
})();